<template>
    <div class="my_treat_page">
        <div class="head">
            <div class="info">
                <div style="display:flex">
                  <div class="text" style="font-size: 16px; font-weight: bold;">
                    {{detail.userName}}
                  </div>
                  <div class="text seeType" v-if="detail.seeType">
                    {{detail.seeType }}
                  </div>
                </div>

                <div  class="text" style="color: #787878">
                    <span>{{detail.sex }}</span>
                    <span> {{detail.age}}</span>
                    <span>{{detail.phone}}</span>
                </div>

            </div>
            <div class="info" style="display: flex; flex-flow: column; align-items: flex-end;">
                <div class="text" style="text-align: center;background: #EAB03C;color: #fff;padding: 3px 8px">{{ detail.serviceTypeName }}<span v-if="detail.refundOrder" style="margin-right: 0;">退款</span></div>
                <div class="text" style="text-align: center;color: #787878">{{ detail.clinicName }}</div>
            </div>
        </div>
        <div class="main_info">
          <div class="main_info">

            <div class="info_line">
              <span>订单编号</span>
              <p v-if="detail.refundOrder">{{ detail.refundOrder.orderSn || '--' }}</p>
              <p v-else>{{ detail.orderSn || '--' }}</p>
            </div>

            <div class="info_line">
              <span>创建时间</span>
              <p>{{ detail.createTime || '--' }}</p>
            </div>

            <div class="info_line">
              <span>支付时间</span>
              <p>{{ detail.payTime || '--' }}</p>
            </div>

            <div class="info_line">
              <span>支付类型</span>
              <p v-if="detail.refundOrder">{{ detail.refundOrder.payType || '--' }}</p>
              <p v-else>{{ detail.payType || '--' }}</p>
            </div>

            <div class="info_line">
              <span>支付单号</span>
              <p v-if="detail.refundOrder">{{ detail.refundOrder.payCode || '--' }}</p>
              <p v-else>{{ detail.payCode || '--' }}</p>
            </div>

            <div class="info_line">
              <span>快递类型</span>
              <p v-if="detail.refundOrder">
                {{
                  detail.refundOrder.isExpress == 0
                      ? '不配送'
                      : detail.refundOrder.isExpress == 1
                          ? '快递配送'
                          : detail.refundOrder.isExpress == 2
                              ? '跑腿闪送'
                              : '--'
                }}
              </p>
              <p v-else>
                {{
                  detail.isExpress == 0
                      ? '不配送'
                      : detail.isExpress == 1
                          ? '快递配送'
                          : detail.isExpress == 2
                              ? '跑腿闪送'
                              : '--'
                }}
              </p>
            </div>

            <div class="info_line">
              <span>订单状态</span>
              <p v-if="detail.refundOrder">{{ detail.refundOrder.orderStatus || '--' }}</p>
              <p v-else>{{ detail.orderStatus || '--' }}</p>
            </div>

            <div class="info_line">
              <span>支付状态</span>

              <p
                  v-if="detail.refundOrder"
                  :style="{ color: (detail.refundOrder.payStatusInt == 2 || detail.refundOrder.payStatusInt == 8) ? '#ef4444' : '#22c55e' }"
              >
                {{ detail.refundOrder.payStatus || '--' }}
              </p>

              <p
                  v-else
                  :style="{ color: (detail.payStatusInt == 2 || detail.payStatusInt == 8) ? '#ef4444' : '#22c55e' }"
              >
                {{ detail.payStatus || '--' }}
              </p>
            </div>

            <div class="info_line">
              <span>制作费</span>
              <p v-if="detail.refundOrder">{{ Math.abs(detail.refundOrder.makeFee || 0).toFixed(2) }}元</p>
              <p v-else>{{ detail.makeFee || '0.00' }}元</p>
            </div>

            <div class="info_line">
              <span>快递费</span>
              <p v-if="detail.refundOrder">{{ Math.abs(detail.refundOrder.freight || 0).toFixed(2) }}元</p>
              <p v-else>{{ detail.freight || '0.00' }}元</p>
            </div>

            <div class="info_line">
              <span>诊金</span>
              <p v-if="detail.refundOrder">{{ Math.abs(detail.refundOrder.consultationFee || 0).toFixed(2) }}元</p>
              <p v-else>{{ detail.consultationFee || '0.00' }}元</p>
            </div>

            <div class="info_line">
              <span>药费</span>
              <p v-if="detail.refundOrder">{{ Math.abs(detail.refundOrder.drugFee || 0).toFixed(2) }}元</p>
              <p v-else>{{ detail.drugFee || '0.00' }}元</p>
            </div>

            <div class="info_line">
              <span>商品费</span>
              <p v-if="detail.refundOrder">{{ Math.abs(detail.refundOrder.sourceGoodsFee || 0).toFixed(2) }}元</p>
              <p v-else>{{ detail.sourceGoodsFee || '0.00' }}元</p>
            </div>

            <div class="info_line">
              <span>总金额</span>
              <p v-if="detail.refundOrder" style="color:#ef4444">
                {{ Math.abs(detail.refundOrder.totalFee || 0).toFixed(2) }}元
              </p>
              <p v-else style="color:#ef4444">
                {{ detail.totalFee || '0.00' }}元
              </p>
            </div>

            <div class="info_line">
              <span>优惠金额</span>
              <p v-if="detail.refundOrder" style="color:#ef4444">
                {{ Math.abs(detail.refundOrder.preferentialPrice || 0).toFixed(2) }}元
              </p>
              <p v-else style="color:#ef4444">
                {{ detail.preferentialPrice || '0.00' }}元
              </p>
            </div>

            <div class="info_line">
              <span>应收金额</span>
              <p v-if="detail.refundOrder" style="color:#ef4444">
                {{ Math.abs(detail.refundOrder.receivableFee || 0).toFixed(2) }}元
              </p>
              <p v-else style="color:#ef4444">
                {{ detail.receivableFee || '0.00' }}元
              </p>
            </div>

            <div class="info_line">
              <span>实收金额</span>
              <p v-if="detail.refundOrder">{{ Math.abs(detail.refundOrder.actFee || 0).toFixed(2) }}元</p>
              <p v-else>{{ detail.actFee || '0.00' }}元</p>
            </div>

            <div class="info_line">
              <span>退款金额</span>
              <p v-if="detail.refundOrder">{{ Math.abs(detail.refundOrder.refundFee || 0).toFixed(2) }}元</p>
              <p v-else>{{ detail.refundFee || '0.00' }}元</p>
            </div>

            <div class="info_line">
              <span>开票金额</span>
              <p v-if="detail.refundOrder">{{ Math.abs(detail.refundOrder.invoicingMoney || 0).toFixed(2) }}元</p>
              <p v-else>{{ detail.invoicingMoney || '0.00' }}元</p>
            </div>

            <div class="info_line">
              <span>订单备注</span>
              <div v-if="detail.refundOrder">
                <p style="width:auto">{{ detail.refundOrder.remark || '--' }}</p>
                <p
                    class="edit-btn"
                    style="color:#3e80f5;width:auto;font-size:12px;"
                    @click="openRemarkDialog('remark')"
                >
                  修改备注
                </p>
              </div>
              <div v-else>
                <p style="width:auto">{{ detail.remark || '--' }}</p>
                <p
                    class="edit-btn"
                    style="color:#3e80f5;width:auto;font-size:12px;"
                    @click="openRemarkDialog('remark')"
                >
                  修改备注
                </p>
              </div>
            </div>

          </div>

        </div>

      <div class="main_info" v-if="showRecipeInfo">
        <div style="font-weight: bold;margin: 20px 0 15px 0">药方信息</div>
        <div class="info_line">
          <span>自煎剂量</span>
          <p>{{detail.dosage || '--'}}</p>
        </div>
        <div class="info_line">
          <span>加工剂量</span>
          <p>{{detail.replaceDosage || '--'}}</p>
        </div>
        <div class="info_line">
          <span>制法</span>
          <p>{{detail.preparation || '--'}}</p>
        </div>
        <div class="info_line">
          <span>医生备注</span>
          <div>
            <p style="width: auto">{{detail.doctorRemark || '--'}}</p>
            <p class="edit-btn" style="color: #3e80f5;width: auto;font-size: 12px" @click="openRemarkDialog('doctorRemark')">修改备注</p>
          </div>

        </div>
        <div class="info_line">
          <span>煎服法</span>
          <p>{{ detail.handleMethod || '--' }}</p>
        </div>

        <div class="info_line" v-if="showDrug">
          <span v-if=" detail.refundOrder && !['0010','0011','0012'].includes(detail.serviceType)" style="width: auto">原</span><span>药方明细</span>
          <p>
            <span
                v-for="(item, index) in detail.drugList"
                :key="index"
                style="padding-right: 0;"
            >
              {{getDrugName(item)}} <span v-if="index < detail.drugList.length - 1">，</span>
            </span>
          </p>
        </div>
      </div>

      <div class="main_info" v-if="showItem">
        <div style="font-weight: bold;margin: 20px 0 15px 0">
          <span v-if=" detail.refundOrder && !['0010','0011','0012'].includes(detail.serviceType)" style="width: auto">原</span>
          项目信息
        </div>
        <p>
          <span
              v-for="(item, index) in detail.drugList"
              :key="index"
          >
            {{item.drug_name}}（{{getDrugNum(item)}}{{item.drug_unit}}<span v-if="item.refund_num && item.refund_num != 0">（退{{ item.refund_num }}）</span>）<span v-if="index < detail.drugList.length - 1">，</span>
          </span>
        </p>
      </div>

<!--      <div class="main_info" v-if="showRefundDrug">-->
<!--        <div style="font-weight: bold;margin: 20px 0 15px 0">-->
<!--          退款药品或项目明细-->
<!--        </div>-->
<!--        <p>-->
<!--          <span-->
<!--              v-for="(item, index) in detail.refundDrugList"-->
<!--              :key="index"-->
<!--          >-->
<!--            {{ item.drug_name }}（{{item.drug_num}}{{item.drug_unit}}）<span v-if="index < detail.drugList.length - 1">，</span>-->
<!--          </span>-->
<!--        </p>-->
<!--      </div>-->
      <div class="foot">
        <div>
          <span>{{ query.status === '0' || query.status === '2' ? '应收：' : '实收：' }}</span>
          <span style="color: #ef4444">
            ￥{{ displayFee }}元
          </span>
        </div>
        <div
            v-if="query.status == '0' || query.status == '2'"
            class="ml-12 h-35 leading-35 px-15 text-white hover:text-white focus:text-white font-bold rounded-full bg-[#CF8C57]"
            @click="send(detail.orderId)"
        >
          微信通知
        </div>
      </div>


      <van-dialog
          v-model="showRemarkDialog"
          :title="dialogTitle"
          show-cancel-button
          @confirm="confirmRemark"
      >
        <div class="dialog-content">
          <van-field
              v-model="editRemark"
              type="textarea"
              rows="5"
              autosize
              maxlength="200"
              placeholder="请输入备注"
              show-word-limit
          />
        </div>
      </van-dialog>
    </div>
</template>
<script>
import {orderdetail, saveorderremark, wxsendpaynotice} from '@/api/medical'
import { mapGetters } from 'vuex'
import {Toast} from "_vant@2.13.6@vant";

export default{
    computed: {
            ...mapGetters([
                'username','dispname','clinicid'
            ]),
            showRecipeInfo() {
              return ['0005', '0001', '0013', '0016'].includes(this.detail.serviceType)
            },
            showDrug(){
              return Array.isArray(this.detail.drugList) && this.detail.drugList.length > 0 && !['0010','0011','0012','0014','0015'].includes(this.detail.serviceType)
            },
            showItem(){
              return Array.isArray(this.detail.drugList) && this.detail.drugList.length > 0 && ['0010','0011','0012','0014','0015'].includes(this.detail.serviceType)
            },
            // showRefundDrug(){
            //   return Array.isArray(this.detail.refundDrugList) && this.detail.refundDrugList.length > 0
            // }
            dialogTitle() {
              switch (this.currentField) {
                case 'doctorRemark':
                  return '修改医生备注'
                case 'remark':
                  return '修改订单备注'
                default:
                  return '修改备注'
              }
            },
            displayFee() {
              // payStatusInt = 8 用 receivableFee - actFee
              if (this.detail.payStatusInt == 8) {
                const fee = this.detail.receivableFee - this.detail.actFee
                return fee !== null && fee !== undefined && !isNaN(fee) ? fee : '--'
              }

              // 普通逻辑
              if (this.query.status === '0' || this.query.status === '2') {
                return this.detail.receivableFee !== null && this.detail.receivableFee !== undefined && this.detail.receivableFee !== ''
                    ? this.detail.receivableFee
                    : '--'
              } else {
                return this.detail.actFee !== null && this.detail.actFee !== undefined && this.detail.actFee !== ''
                    ? this.detail.actFee
                    : '--'
              }
            }
        },
    data(){
        return{
            detail:{},
            query:{},
            showRemarkDialog: false,
            editRemark: '',
            currentField: '',
            currentRemarkType:''
        }
    },
    mounted(){
        this.$store.dispatch('hideOrShowNav', false)
        // this.detail = JSON.parse(localStorage.getItem('UserInfoDetail'))
        // console.log(JSON.parse(localStorage.getItem('UserInfoDetail')))
        // if(!this.detail){
              this.getorderinfo()
        // }

    },
    methods:{
        getorderinfo(){
            Toast({
              type: "loading",
              duration: 0,
            });
            this.query.orderid = this.$route.query.orderid;
            this.query.status = this.$route.query.status;
            orderdetail(this.query).then(response =>{
                if(response.response_body.msg){
                  this.detail = response.response_body.detail;
                }else{
                  Toast.fail(response.response_body.errorMsg);
                }
                this.$nextTick(() => {
                  if (Toast) {
                    Toast.clear();
                  }
                });
            })
        },
        getDrugNum(item) {
          const type = this.detail.serviceType
          const specialTypes = ['0010', '0011', '0012', '0014','0015']

          // 0010 / 0011 / 0012 / 0015：直接用 drug_num
          if (specialTypes.includes(type)) {
            return 'X'+item.drug_num
          }

          // 其他类型：drug_num * (dosage + replaceDosage)
          const dosage = Number(this.detail.dosage || 0)
          const replaceDosage = Number(this.detail.replaceDosage || 0)

          return item.drug_num * (dosage + replaceDosage)
        },
        getDrugName(item) {
          //{{item.drug_name}}（{{getDrugNum(item)}}{{item.drug_unit}}<span v-if="item.refund_num && item.refund_num != 0">（退{{ item.refund_num }}）</span><span v-if="item.item_name">/{{item.item_name}}</span>）<span v-if="index < detail.drugList.length - 1">，</span>
          let name = item.drug_name;
          let num = this.getDrugNum(item) + item.drug_unit;
          let refund = '';
          if (item.refund_num && item.refund_num != 0){
            refund = '（退'+item.refund_num+'）';
          }
          let itemName = '';
          if(item.item_name){
            itemName = '/'+item.item_name;
          }
          let isOwned = '';
          if (item.is_owned == 1){
            isOwned = '，自备'
          }
          let drugType = this.getDrugType(item.drug_type);

          return name+'（'+num + refund + itemName+ isOwned +'）'+drugType
        },
        getDrugType(type){
          let typeName = '';
          if (!type){
            return typeName;
          }
          if (type == 1){
            typeName = '-饮'
          }
          if (type == 2){
            typeName = '-颗'
          }
          if (type == 3){
            typeName = '-私'
          }
          if (type == 5){
            typeName = '-商'
          }
          if (type == 8){
            typeName = '-包'
          }
          return typeName;
        },
        //发送微信通知
        send(orderid) {
          this.$dialog.confirm({
            title: '提示',
            message: '是否通知客户付款？付款通知将通过微信公众号下发模板消息，请提醒客户注意查收',
          }).then(() => {
            // 确认
            Toast({
              type: "loading",
              duration: 0,
            });
            let data = {
              orderid: orderid,
            };
            wxsendpaynotice(data).then(response => {
              if (Toast) {
                Toast.clear();
              }

              if(response.response_body.msg){
                Toast.success('推送成功');
              }else{
                Toast.fail(response.response_body.errorMsg);
              }
            });
          }).catch(() => {
            // 取消

          })

        },
        openRemarkDialog(field) {
          this.currentField = field
          this.editRemark = this.detail[field] || ''
          this.showRemarkDialog = true
          if (field === 'remark') {
            this.currentRemarkType = 1
          } else if (field === 'doctorRemark') {
            this.currentRemarkType = 2
          } else {
            this.currentRemarkType = null
          }
        },
        confirmRemark() {
          Toast({
            type: "loading",
            duration: 0,
          });
          let data = {
            orderid: this.detail.orderId,
            type: this.currentRemarkType,
            remark: this.editRemark,
            username: this.username
          };
          saveorderremark(data).then(response => {
            if (Toast) {
              Toast.clear();
            }

            if(response.response_body.flag){
              Toast.success('修改成功');

              this.detail[this.currentField] = this.editRemark
              this.showRemarkDialog= false;
              this.editRemark = '';
              this.currentField = '';
              this.currentRemarkType='';
            }else{
              Toast.fail(response.response_body.errorMsg);
            }
          });
        }
    }

}
</script>
<style lang="scss" scoped>
.my_treat_page{
    margin-bottom: 0;
    min-height: 100vh;
    background-color: #F6F6F4;
    padding-bottom: 0;
    .head{
        background-color: #E7EBF7;
        border-radius: 10px;

        font-size: 12px;
        padding: 15px;
        display: flex;
        align-items: center;
        font-size: 12px;
        justify-content: space-between;
        .text {
          margin-bottom: 10px;

          span {
            margin-right: 8px;
          }

          &.seeType {
            color: #EAB03C;
            border: 1px solid #EAB03C;
            padding: 1px 3px;
            margin-left: 5px;
          }
        }
    }
    .main_info{
        margin-top: -20px;
        .info_line{
          align-items: start;
          margin-bottom: 0.2rem;
        }
        .info_line span{
          padding-right: 0;
        }
        .info_line p{
          //超出多少行显示省略号
          -webkit-line-clamp: unset !important;
        }
      .info_li
        .info_line p{
          //超出多少行显示省略号
          -webkit-line-clamp: unset !important;
        }
    }
    .list{
        background-color: #fff;
        border-radius: 10px;
        margin-top: -15px;
        padding: 15px 12px;
        margin-bottom: 80px;
        .list_top{

            display: flex;

                flex-wrap: wrap;
            .user{
                width: 95px;
                height: 45px;
                padding: 5px;
                text-align: center;
                background-color: #F5F5F5;
                border-radius: 8px;
                margin-right: 8px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;
                margin-bottom: 8px;

                .item{
                    width: 80px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

            }
            .active{
                background: rgba(207,140,87,0.2);
                border-radius: 8px;
                border: 1px solid #CF8C57;
            }
        }
        .list_btn{
            width: 140px;
            height: 35px;
            line-height: 35px;
            border-radius: 17.5px;
            background-color: #CF8C57;
            font-size: 16px;
            color: #fff;
            text-align: center;
            margin-bottom: 10px;
        }
        .list_item{
            background-color: #F5F5F5;
            border-radius: 10px;
            padding: 10px;
            margin-bottom: 10px;

            .tream{
                display: flex;
                justify-content: space-between;
                align-items: center;
                .text{
                    font-weight: 600;
                    font-size: 16px;
                    color: #323333;
                    line-height: 22px;
                    text-align: left;
                }
            }
        }
    }
    .btn_detail_info{
        flex-wrap: wrap;
        padding: 5px;
        padding-left: 20px;
        :nth-child(3){
            border-right: unset;
        }
        .btn_div{
            margin: 5px 0;
            width: 32%;
            font-size: 12px;
            padding: 5px;

            // padding-left: 10px;
            // width: unset;
            // margin: 10px 0;
            img{
                width: 15px;
                height: 15px;
                margin-right: 5px;
            }
        }
    }
    .van-cell{
        padding:0 5px 5px;
        background-color: #F5F5F5;

        ::v-deep .van-icon {
            display: flex;
            align-items: center;
        }
    }

    .foot{
      background: #F6F6F4;
      position: sticky;
      bottom: 0;
      display: flex;
      font-size: 16px;
      height: 65px;
      align-items: center;
      padding: 5px 5px 25px 5px;
      justify-content: space-between;
    }

  .edit-btn {
    margin-left: 10px;
    color: #1989fa;
    font-size: 12px;
    cursor: pointer;
  }
  .dialog-content{
    padding: 0 15px;
    height: 200px;          /* 固定高度 */
    box-sizing: border-box;
    overflow-y: auto;       /* 内容超出可滚动 */
  }
}

::v-deep .van-checkbox__label{
    width: 100% !important;
}
.my_treat_page .van-cell {
    ::v-deep .van-field{

        background-color: #fff;
    }
}
.van-dialog{

    ::v-deep .van-dialog__header{
        padding: 10px 0  25px !important;
    }
    ::v-deep .van-field{
        background-color: #fff;
        margin-bottom: 5px;
    }
}

</style>
